import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import every24HoursPreviewType from "@/types/responses/every24HoursPreview";

type rowItemType = {
  id: string,
  dataName: string,
  dataKey: string,
  class: string,
  isConvertToJson: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableRow',
  props: {
    deliveryPlan: {},
    index: {},
    rowItems: {},
    chartDetails: {}
  },
  setup(__props: any) {

const props = __props;

function displayData(dataKey: string) {
  return props.chartDetails ? props.chartDetails[dataKey] : props.deliveryPlan[dataKey];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tbody", null, [
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rowItems, (item) => {
        return (_openBlock(), _createElementBlock("td", {
          key: item,
          class: _normalizeClass(item.class)
        }, _toDisplayString(displayData(item.dataKey)), 3))
      }), 128))
    ])
  ]))
}
}

})